// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import './assets/bootstrap/css/bootstrap.min.css'
//import './assets/zoomify/bootstrap-grid.min.css'
import './assets/zoomify/zoomify.min.css'
import './assets/zoomify/style.css'
import './assets/zoomify/zoomify.min'
import './assets/css/base-style.css'
import './assets/bootstrap/js/bootstrap.min'
import './assets/js/jquery.form'
import Vue from 'vue'
import Main_page from './main_page'
import router from './router/index.js'
import VueResource from 'vue-resource'
import store from './vuex/store'
import {
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Input,
	DatePicker,
	Carousel,
	CarouselItem,
	CollapseItem,
	Collapse,
	Upload,
	Dialog,
	Pagination,
	MessageBox,
	Steps,
	Step,
  Select,
  Option,
  OptionGroup,
  Progress,
  Message,
} from 'element-ui'
import Tip from './components/tip.vue'
import confirm from './components/confirm/confirm.vue'
import inputFocus from './assets/js/inputFocus'
import vLogo 		from './components/loginGroup/logo_head.vue'

Vue.use(VueResource);
Vue.use(OptionGroup);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Input);
Vue.use(DatePicker);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(CollapseItem);
Vue.use(Collapse);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(inputFocus);
Vue.use(Select);
Vue.use(Option);
Vue.use(Pagination);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Progress);

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message

Vue.component('v-tip',Tip);
Vue.component('v-confirm',confirm);
Vue.component('v-logo',vLogo);
//非空
Vue.directive('vz-notNull',{
	inserted:function(el,binding,vnode){
		$(el).blur(function(){
			if( binding.arg == "notNull" && el.value === "" ){
				$("#one").modal().find(".state_text").html(binding.expression + "不能为空!")
			}

		})
	}
})

/******************拦截器设置请参考这部分(开始)******************/
Vue.http.interceptors.push((request, next) => {
	//登录成功后将后台返回的TOKEN在本地存下来,每次请求从sessionStorage中拿到存储的TOKEN值
	let TOKEN = localStorage.getItem('token');
	if(TOKEN) {
		//如果请求时TOKEN存在,就为每次请求的headers中设置好TOKEN,后台根据headers中的TOKEN判断是否放行
		request.headers.set('Authorization', "Bearer " + TOKEN);
	}
	next((response) => {
//		console.log(response.status);
		if(response.status == '401') {
			alert('登录超时，请重新登录');
			router.replace('/login');
		}

		return response;
	});
});

/******************拦截器设置请参考这部分(结束)******************/

/* eslint-disable no-new */
new Vue({
	el: '#index',
	store,
	router,
	template: '<Main_page/>',
	components: { Main_page }
})

Vue.filter('time', function(value) {
	if(value){
		function checkTime(i) {
		if(i < 10) { i = "0" + i }
		return i
	}
	var d = new Date(parseInt(value));
	var year = d.getFullYear();

	var month = checkTime(parseInt(d.getMonth()) + 1);

	var date = checkTime(d.getDate());

	var hour = checkTime(d.getHours());

	var minute = checkTime(d.getMinutes());

	var second = checkTime(d.getSeconds());

	return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
	}else{
		return ''
	}


})
Vue.filter('datetime', function(value) {

	function checkTime(i) {
		if(i < 10) { i = "0" + i }
		return i
	}
	var d = new Date(value);
	var year = d.getFullYear();

	var month = checkTime(parseInt(d.getMonth()) + 1);

	var date = checkTime(d.getDate());

	var hour = checkTime(d.getHours());

	var minute = checkTime(d.getMinutes());

	var second = checkTime(d.getSeconds());

	return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
})


Vue.filter('msgNum', function(num) {
	if( num > 99 ) num = 99;
	return num;
})

Vue.filter('fmtMoney', function(value) {
	var val = value;
	return parseInt(val);
})


Vue.prototype.offList = function() {
	//		alert(12)
}




// WEBPACK FOOTER //
// ./src/main.js